(() => {
  const spendSelector = '[data-left-to-spend]';
  const goalSelector = 'f-cart-goal';
  const observeOptions = {
    childList: true,
    characterData: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-hulkapps-cart-total'],
  };

  const stripHulkCartTotalHook = (root) => {
    root.querySelectorAll(`${spendSelector}[data-hulkapps-cart-total]`).forEach((el) => {
      el.removeAttribute('data-hulkapps-cart-total');
    });
  };

  const restoreRemainingFromGoal = (goalEl) => {
    if (typeof goalEl.updateCartGoal !== 'function' || !Number.isFinite(goalEl.cartTotal)) return;
    goalEl.updateCartGoal(Math.round(goalEl.cartTotal * 100));
  };

  const protectGoal = (goalEl) => {
    const spendEl = goalEl.querySelector(spendSelector);
    if (!spendEl || spendEl.dataset.customCartGoalProtected === 'true') return;

    spendEl.dataset.customCartGoalProtected = 'true';
    stripHulkCartTotalHook(goalEl);

    const observer = new MutationObserver(() => {
      observer.disconnect();
      stripHulkCartTotalHook(goalEl);
      restoreRemainingFromGoal(goalEl);
      observer.observe(spendEl, observeOptions);
    });

    observer.observe(spendEl, observeOptions);
  };

  const protectAll = () => {
    document.querySelectorAll(goalSelector).forEach(protectGoal);
  };

  protectAll();
  document.addEventListener('DOMContentLoaded', protectAll);

  const subscribe = () => {
    if (!window.FoxThemeEvents?.subscribe || typeof PUB_SUB_EVENTS === 'undefined') return false;
    window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.cartUpdate, protectAll);
    return true;
  };

  if (!subscribe()) {
    document.addEventListener('DOMContentLoaded', subscribe);
  }
})();
